import { atom, useAtom } from "jotai";
import { useCallback } from "react";

const activeMobileMenuSectionAtom = atom<string | undefined>(undefined);

export const useActiveSection = () => {
  const [activeSection, setActiveSection] = useAtom(
    activeMobileMenuSectionAtom,
  );

  const reset = useCallback(() => {
    setActiveSection(undefined);
  }, [setActiveSection]);

  return {
    activeSection,
    reset,
    setActiveSection,
  };
};
